module.exports = __webpack_public_path__ + "img/logo.290b771d.png";